import { API_URL } from '../../../config';
import { toApiError } from '../../../lib/api-error';

export type WorkflowValidationListItem = {
  id: string;
};

type WorkflowValidationListResponse = {
  workflows?: WorkflowValidationListItem[];
};

export async function fetchWorkflowValidationList(): Promise<WorkflowValidationListItem[]> {
  const response = await fetch(`${API_URL}/workflows`, { credentials: 'include' });
  if (!response.ok) throw await toApiError(response, 'Failed to fetch workflows');

  const data = (await response.json()) as WorkflowValidationListResponse;
  return Array.isArray(data.workflows) ? data.workflows : [];
}
